import { render, staticRenderFns } from "./SingleLeaderboardTable.vue?vue&type=template&id=7ad0474c&scoped=true&"
import script from "./SingleLeaderboardTable.vue?vue&type=script&lang=js&"
export * from "./SingleLeaderboardTable.vue?vue&type=script&lang=js&"
import style0 from "./SingleLeaderboardTable.vue?vue&type=style&index=0&id=7ad0474c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad0474c",
  null
  
)

export default component.exports